import { ACTIONS } from '../Constants';
import { buildQueryString } from '../utils/StringUtils';
import { VerbFetch } from '../VerbFetch';

export const getAbility = (params) => {
    const { id, pathsContext } = params;

    return (dispatch) =>
        VerbFetch(`${pathsContext.serverUrl}/abilities/${id}`).then((body) => {
            dispatch({
                type: ACTIONS.GET_ABILITY,
                payload: {
                    ability: body
                }
            });
        });
};

export const postAbility = (params) => {
    const { body, pathsContext } = params;
    const uri = `${pathsContext.adminServerUrl}/abilities`;
    const fetchOptions = {
        method: 'POST',
        body
    };
    return (dispatch) => {
        dispatch({
            type: ACTIONS.POST_ABILITY_START,
            payload: {
                body
            }
        });
        return VerbFetch(uri, fetchOptions)
            .then((response) => {
                dispatch({
                    type: ACTIONS.POST_ABILITY_SUCCESS,
                    payload: {
                        ability: response
                    }
                });
                return response;
            })
            .catch((err) => err);
    };
};

export const putAbility = (params) => {
    const { id, body, pathsContext } = params;
    const uri = `${pathsContext.adminServerUrl}/abilities/${id}`;
    const fetchOptions = {
        method: 'PUT',
        body
    };
    return (dispatch) => {
        dispatch({
            type: ACTIONS.PUT_ABILITY_START,
            payload: {
                body
            }
        });
        return VerbFetch(uri, fetchOptions)
            .then((response) => {
                dispatch({
                    type: ACTIONS.PUT_ABILITY_SUCCESS,
                    payload: {
                        ability: response
                    }
                });
                return response;
            })
            .catch((err) => err);
    };
};

export const getManyAbilities = (params) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.serverUrl}/abilities`;
    const url = buildQueryString(rest, baseUrl);

    return (dispatch) =>
        VerbFetch(url)
            .then((body) => {
                dispatch({
                    type: ACTIONS.GET_MANY_ABILITIES,
                    payload: {
                        abilities: body
                    }
                });
                return body;
            })
            .catch(console.error);
};
